import { PropsWithChildren } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

import { adjustersFlowName } from 'views/AdjustersHub/constants'

const isAdjustersPage = location.pathname.includes(adjustersFlowName)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnMount: false,
      refetchOnReconnect: isAdjustersPage ?? false,
      refetchOnWindowFocus: false,
    },
  },
})

const QueryProvider = ({ children }: PropsWithChildren): JSX.Element => (
  <QueryClientProvider client={queryClient}>
    {children}
    {/*  Only rendered when process.env.NODE_ENV === 'development' */}
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
)

export default QueryProvider
